import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { messages } from '../../containers/Filter/Filter.i18n';

class CollapseButton extends React.Component {
  render() {
    const { formatMessage } = this.props.intl;

    const variant = this.props.variant || null
    const toggleClass = !this.props.isOpen ? 'collapsed' : '';
    const buttonText = this.props.isOpen ?
      formatMessage(messages.filter.hidefilter) : formatMessage(messages.filter.showfilter);

    const toggleIcon = this.props.isOpen ? 'fa-caret-up' : 'fa-caret-down';
    const customIcon = (this.props.icon) ? `fa-${this.props.icon}` : ''

    return (
      <Button className={toggleClass} variant={variant} onClick={this.props.onClick} style={{ width: 'auto' }}>
        <span className="pull-left">
          <i className={`fa-solid ${customIcon || toggleIcon}`}></i>&ensp;
          { buttonText }
        </span>
      </Button>
    );
  }
}

CollapseButton.propTypes = {
  onClick: PropTypes.func,
  isOpen: PropTypes.bool,
  intl: PropTypes.object,
  variant: PropTypes.string,
  icon: PropTypes.string,
};

export default injectIntl(CollapseButton);